import { useEffect } from 'react'

/** @param {object} m */
export function useAbortOnThreadChange(m) {
  const { displayThreadId, chatAbortRef, prevDisplayThreadRef } = m
  useEffect(() => {
    const prev = prevDisplayThreadRef.current
    prevDisplayThreadRef.current = displayThreadId
    if (prev === displayThreadId) return
    if (prev === null && displayThreadId !== null) return
    chatAbortRef.current?.abort()
  }, [displayThreadId, chatAbortRef, prevDisplayThreadRef])
}
